import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { AppMetadataHandler } from 'app'

@Component({
  selector: 'app-hospital-details',
  templateUrl: './hospital-details.component.html',
  styleUrls: ['./hospital-details.component.scss']
})
export class HospitalDetailsComponent implements OnInit {

  constructor(
    public appMetadataHandler: AppMetadataHandler
  ) { }

  ngOnInit() {
  }

  modHospDetails
  modDocDetails

  @Input() dataSet: any
}



